import { firstValueFrom } from 'rxjs';
import { Component } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

export interface ThingsToEmptyPayload {
  entity?: string;
  threshold?: number;
  start?: number;
  end?: number;
}

export interface CollectorScopePayload {
  operator_id: string;
  client_ids?: string[];
}

type RestAction =
  | 'getCollectorZones'
  | 'getCollectorBinsToCollect'
  | 'getCollectorOptimizedRoutes';

@Component({
    selector: 'app-rest-test',
    imports: [],
    templateUrl: './rest-test.component.html',
    styleUrl: './rest-test.component.css'
})
export class RestTestComponent {
  //  apiUrl = "https://opmwt5w67b.execute-api.ca-central-1.amazonaws.com/IFM2/things";
   apiKey = "98eXdgoMPX9L3Ne2X9Ctf1Z2Wt0HFxRm2ghtAHmM";
   apiUrl = "https://api.mwstudio.io/things";

   constructor(private http:HttpClient){

   }

  private readonly sampleThingsPayload: ThingsToEmptyPayload = {
    entity: 'OPf14be1aab364065546',
    threshold: 90,
    start: 1751400000,
    end: 1754000000,
  };

  private readonly sampleCollectorPayload: CollectorScopePayload = {
    operator_id: 'OPf14be1aab364065546',
    client_ids: ['CLdf8ac35094d7c73fc5'],
  };

  getThingsToEmpty(payload: ThingsToEmptyPayload) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-key': this.apiKey
    });

    const body = {
      entity: payload.entity ?? 'CLdf8ac35094d7c73fc5',
      threshold: payload.threshold ?? 80,
      start: payload.start ?? 1751328000,
      end: payload.end ?? 1754006399
    };

    return firstValueFrom(
      this.http.post<any>(
        this.apiUrl,
        body,
        {
          headers: headers,
          observe: 'body', // Ensures full observable return
          responseType: 'json' // Ensures it's parsed
        }
      )
    );
  }

  private callCollectorAction(action: RestAction, payload: CollectorScopePayload) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-key': this.apiKey
    });

    return firstValueFrom(
      this.http.post<any>(
        this.apiUrl,
        {
          action,
          operator_id: payload.operator_id,
          client_ids: payload.client_ids ?? []
        },
        {
          headers,
          observe: 'body',
          responseType: 'json'
        }
      )
    );
  }

  async runThingsToBeCollected(): Promise<void> {
    try {
      const res = await this.getThingsToEmpty(this.sampleThingsPayload);
      console.log('thingsToBeCollected result:', res);
    } catch (error) {
      console.error('thingsToBeCollected error:', error);
    }
  }

  async runGetCollectorZones(): Promise<void> {
    try {
      const res = await this.callCollectorAction('getCollectorZones', this.sampleCollectorPayload);
      console.log('getCollectorZones result:', res);
      const zones = Array.isArray(res?.data) ? res.data : [];
      const zonesWithPolygon = zones.map((zone: any) => {
        let polygon = zone?.zone_coordinates;
        if (typeof polygon === 'string') {
          try {
            polygon = JSON.parse(polygon);
          } catch {
            // keep original value if it is not valid JSON
          }
        }
        return {
          zone_id: zone?.zone_id,
          zone_name: zone?.zone_name,
          zone_coordinates: polygon
        };
      });
      console.log('getCollectorZones polygon data:', zonesWithPolygon);
    } catch (error) {
      console.error('getCollectorZones error:', error);
    }
  }

  async runGetCollectorBinsToCollect(): Promise<void> {
    try {
      const res = await this.callCollectorAction('getCollectorBinsToCollect', this.sampleCollectorPayload);
      console.log('getCollectorBinsToCollect result:', res);
    } catch (error) {
      console.error('getCollectorBinsToCollect error:', error);
    }
  }

  async runGetCollectorOptimizedRoutes(): Promise<void> {
    try {
      const res = await this.callCollectorAction('getCollectorOptimizedRoutes', this.sampleCollectorPayload);
      console.log('getCollectorOptimizedRoutes result:', res);
    } catch (error) {
      console.error('getCollectorOptimizedRoutes error:', error);
    }
  }



}
